// extracted by extract-css-chunks-webpack-plugin
module.exports = {"auctionVideo":"auctionVideo___lvDwA","mini":"mini___1cq4U"};